import Tabs from './Tabs';

export { default as Tab } from './Tab';
export type { TabConfig } from './Tabs';
export { default as Tabs } from './Tabs';

export default Tabs;
